"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
var emotion_1 = require("emotion");
exports.timezone = emotion_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    font-family: Noto Regular;\n    font-size: 12px;\n    color: #8f9399;\n"], ["\n    font-family: Noto Regular;\n    font-size: 12px;\n    color: #8f9399;\n"])));
var templateObject_1;
